<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="tooltipText"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="height:100%; margin-bottom: 0px !important"
      >
        <!--
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          {{ uniTranslation("S430") }}
        </div>
        -->
        <div
          v-if="localPath == '.left'"
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
        >
          <!-- Primary Side -->
          {{ uniTranslation("PHE821") }}
        </div>
        <div
          v-if="localPath == '.right'"
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
        >
          <!-- Secondary Side -->
          {{ uniTranslation("PHE822") }}
        </div>

        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->

        <RefrigerantPicker :path="path"></RefrigerantPicker>

        <el-checkbox v-model="showFluidFlow">{{ uniTranslation("TRNSL42") }}</el-checkbox>

        <div v-if="showFluidFlow">
          <UnidataEditor :parent-path="path" :name="'.flow'"></UnidataEditor>
        </div>

        <div v-show="refrigerantWithGlide">
          <UnidataEditorCorrelator
            ref="CONDGlideEvap"
            :parent-path="path"
            group="EvaporatingGlideGroup"
            @changedcombo="setTipoGlide"
          ></UnidataEditorCorrelator>
          <UnidataEditorCorrelator
            ref="CONDGlideCond"
            :parent-path="path"
            group="CondensingGlideGroup"
            @changedcombo="setTipoGlide"
          ></UnidataEditorCorrelator>
        </div>

        <div v-show="!refrigerantWithGlide">
          <UnidataEditor
            ref="EvapMiddle"
            :parent-path="path"
            :name="'.evaporatingTemperatureMiddle'"
          ></UnidataEditor>
          <UnidataEditor
            ref="CondMiddle"
            :parent-path="path"
            :name="'.condensingTemperatureMiddle'"
          ></UnidataEditor>
        </div>

        <UnidataEditor :parent-path="path" :name="'.subcooling'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.overHeating'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.pressureDrop'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.foulingFactor'"></UnidataEditor>

        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        <!--
        <UnidataEditor :parent-path="path" :name="'.fluidVelocityLiquidPhase'"></UnidataEditor>
        -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
import { mapGetters } from "vuex";
import { Checkbox } from "element-ui";
import RefrigerantPicker from "../shared/RefrigerantPicker";
import colorsService from "../../services/backend/colorsService";

export default {
  components: {
    UnidataEditor,
    RefrigerantPicker,
    UnidataEditorCorrelator,
    "el-checkbox": Checkbox /*,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      hasGlide: false,
      showFluidFlow: false, // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
      coloreSfondo: "",
      coloreTesto: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreSfondoTab: "",
      coloreTestoTab: "",
      coloreBordo: "",
      refrigerantWithGlide: false,
      unsubscribes: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"]),

    tooltipText() {
      var tmpPath = this.localPath;
      if (tmpPath.includes(".left")) {
        //Primary Side
        return this.uniTranslation("PHE821", "en-US");
      }
      if (tmpPath.includes(".right")) {
        //Secondary Side
        return this.uniTranslation("PHE822", "en-US");
      }
      return this.uniTranslation("S430", "en-US");
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = that.cardColors[1];
    that.coloreTesto = that.cardColors[2];
    that.coloreTitolo = that.cardColors[3];
    that.coloreSfondoTab = that.cardColors[4];
    that.coloreTestoTab = that.cardColors[5];
    that.coloreBordo = that.cardColors[6];
    //----
    that.unsubscribes.push(
      that.$store.subscribe(function(mutation /*, state*/) {
        if (mutation.type === "changeProjectProperty") {
          if (mutation.payload.path == that.path + ".fluid.hasGlide") {
            if (that.refrigerantWithGlide != mutation.payload.value) {
              if (mutation.payload.value) {
                let Te = that.$refs.EvapMiddle.getValue();
                let Tc = that.$refs.CondMiddle.getValue();
                that.$refs.CONDGlideEvap.setRefValue(Te.value, Te.um);
                that.$refs.CONDGlideCond.setRefValue(Tc.value, Tc.um);
              } else {
                let Te = that.$refs.CONDGlideEvap.getRefValue(2, "°C");
                let Tc = that.$refs.CONDGlideCond.getRefValue(45, "°C");
                that.$refs.EvapMiddle.setValue(Te.value, Te.um);
                that.$refs.CondMiddle.setValue(Tc.value, Tc.um);
              }
              that.refrigerantWithGlide = mutation.payload.value;
            }
          }
        }
      })
    );
  },
  methods: {
    setTipoGlide(NewVal) {
      var newValue = 1;
      var pathTipo = "";

      if (NewVal.includes("condensing")) pathTipo = this.path + ".glideTypeCond";

      if (NewVal.includes("evaporating")) pathTipo = this.path + ".glideTypeEvap";

      if (NewVal.includes("Dew")) newValue = -1;
      if (NewVal.includes("Middle")) newValue = 0;
      if (NewVal.includes("Bubble")) newValue = 1;

      if (pathTipo != "") {
        this.$store.dispatch("changeProjectProperty", {
          path: pathTipo,
          value: newValue
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
